import React, { useEffect } from 'react';
import SidebarItem from './SidebarItem';
import { Context } from '../../config/store';
import admin from './admin';
import affiliate from './affiliate';
import { useRouter } from '../../hooks/useRouter';
import logo from '../../assets/logo.png'
import MasterDataService from '../../services/master-data';

// import dsa from './dsa';
const Sidebar = () => {
	const { state,dispatch } = React.useContext(Context);
	const [open, setOpenState] = React.useState(false);
	const [showIconOnly, setShowIconOnly] = React.useState(false)
	const [checkMenuBarPermission, setCheckMenuBarPermission] = React.useState(0);
	const router = useRouter();
	const items = {
		admin,
		affiliate,
		lender: affiliate,
		// dsa
	};
	// API call
	useEffect(() => {
		checkMenuPermission();
	}, [state.is_super_admin]);

	const checkMenuPermission = async () => {
		try {
			if(state?.user?.user_id){
				const response = await MasterDataService.getUserType(
					state.userType,
					state.userType === 'admin' ? 'co-lender' : '',
					state?.user?.user_id
				);
				console.log("ram ji - ", response?.data?.data?.status);
				setCheckMenuBarPermission(response?.data?.data?.status); 
			}
		} catch (error) {
		console.error("Error fetching menu:", error);
		}
	};
	const checkHasPermission = (sidebarMenu) => {
		if (state.is_super_admin === 1 && checkMenuBarPermission === 1) return sidebarMenu;
		const permission = state.permission.find(
			(permission) => (sidebarMenu.permission || '').split(',').includes(permission)
		);
		if (permission) return sidebarMenu;
		else return false;
	};

	return (
		<nav className='sidebar'>
			{/* <div className="col-2 my-2 align-items-center" style={{ cursor: 'pointer' }}>
				<img src={logo} width={'80%'} onClick={() => { router.navigate('/portfolio/home') }} style={{height:"40px",width:'140px',paddingLeft:"20px"}} />
			</div> */}
			<ul className='nav flex-column' id='nav_accordion'>
				<label
					htmlFor='handler'
					className='handler'
					onClick={() => {
						setShowIconOnly(!showIconOnly)
						setOpenState(!open)
						dispatch({
							type: 'sidebarOpen',
							sidebarOpen: open,
						})
					}}
				>
					{open ? (
						<i className='fa fa-chevron-right'></i>
					) : (
						<i className='fa fa-chevron-left'></i>
					)}
				</label>
				{items[state.userType]
					.filter((sidebarMenu) =>
						sidebarMenu.permission
							? checkHasPermission(sidebarMenu)
							: sidebarMenu
					)
					.map((sidebarItem, index) => (
						<SidebarItem {...sidebarItem} key={sidebarItem.id} showIconOnly={showIconOnly} />
					))}
			</ul>
		</nav>
	);
};

export default Sidebar;
